
import { createApiClient } from 'Network/ApiClient';

export const DrugNotCoveredAxiosInstance = createApiClient('DrugsNotCovered/');


